const defaultTimeZone = 'Europe/Stockholm'

export default function getDeviceTimeZone (): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch {
    return defaultTimeZone
  }
}
